import React from "react";
import PropTypes from "prop-types";

const StandardsCell = ({ value }) => (
  <div dangerouslySetInnerHTML={{ __html: value }} />
);

StandardsCell.propTypes = {
  value: PropTypes.string,
};

// Function to format severity and description
const formatDetails = (details, key) => {
  return `
    <strong class="severity-block">
      ${details[key].severity}
    </strong>
    <br/>${details[key].description}
  `;
};

export const getSharedLibData = (record) =>
  (record.binary_analysis || []).map((details, index) => ({
    id: index,
    object: details.name,
    nx: formatDetails(details, "nx"),
    pie: formatDetails(details, "pie"),
    canary: formatDetails(details, "stack_canary"),
  }));

// Static columns definition
export const sharedLibColumns = [
  {
    Header: "Shared Object",
    accessor: "object",
  },
  {
    Header: "NX",
    accessor: "nx",
    Cell: StandardsCell,
  },
  {
    Header: "PIE",
    accessor: "pie",
    Cell: StandardsCell,
  },
  {
    Header: "Stack Canary",
    accessor: "canary",
    Cell: StandardsCell,
  },
];

export const sharedLibTitle = "category-title-shared-libraries";
